import { render, staticRenderFns } from "./DetTicketsForm.vue?vue&type=template&id=57a41488"
import script from "./DetTicketsForm.vue?vue&type=script&lang=js"
export * from "./DetTicketsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports